import axios from './index';

class BullionDeskApi {
  static List = (data) => {
    console.log('Query in data', data);
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.selectedTypeValue) {
      query += `type=${data.selectedTypeValue}&`;
    }
    if (data.selectedLocationValue) {
      query += `operation_location_id=${data.selectedLocationValue}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static GetById = (id) => {
    return axios.get(`${base}/${id}`);
  };

  static Create = (data) => {
    let request = {
      unit: data.unit,
      type: data.type,
      start: data.start,
      expiry: data.expiry,
      operation_location_id: data.operationLocationId,
      buy: Number(data.buy),
      sell: Number(data.sell),
      // exchange: Number(data.exchange),
      threshold_sell: Number(data.threshold_sell),
      threshold_buy: Number(data.threshold_buy),
      threshold_sell_addon: Number(data.threshold_sell_addon),
      threshold_buy_addon: Number(data.threshold_buy_addon),
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.unit) request.unit = data.unit;
    if (data.type) request.type = data.type;
    if (data.start) request.start = data.start;
    if (data.expiry) request.expiry = data.expiry;
    if (data.operationLocationId)
      request.operation_location_id = data.operationLocationId;
    if (data.buy) request.buy = Number(data.buy);
    if (data.sell) request.sell = Number(data.sell);
    // if (data.exchange) request.exchange = Number(data.exchange);
    if (data.locker_sell) request.locker_sell = Number(data.locker_sell);
    if (data.locker_buy) request.locker_buy = Number(data.locker_buy);
    if (data.saving_plan_sell)
      request.saving_plan_sell = Number(data.saving_plan_sell);
    if (data.saving_plan_buy)
      request.saving_plan_buy = Number(data.saving_plan_buy);

    return axios.put(`${base}/${data.bullionDeskId}`, request);
  };

  static Delete = (id) => {
    let request = {};
    request.is_active = false;
    return axios.put(`${base}/${id}`, request);
  };
}

let base = 'dashboard/bullion-desk';

export default BullionDeskApi;
